import './Categories.scss';
import Component from './Categories.js';
export default Component;
